module.exports = __webpack_public_path__ + "img/markerStopLight.06013970.svg";